module.exports = __webpack_public_path__ + "images/thumb-up-filled52ba33d03f6614e18488c7843718012e.svg";